import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormAssessmentTeamSummaryService } from "../../../../Services/FormAssessmentTeamSummaryService";
import { IFormAssessmentTeamSummary } from "../../../../Models/Forms/IFormAssessmentTeamSummary";
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { IFormBase } from 'src/app/Models/Forms/IFormBase';
import { SpinnerBase } from '../../../Base/SpinnerBase';

@Component({
  selector: 'AssessmentTeamSummary',
  templateUrl: './AssessmentTeamSummary.component.html',
  styleUrls: ['./AssessmentTeamSummary.component.css']
})

export class FormAssessmentTeamSummaryComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _reportService: ReportService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  formAssessmentTeamSummaryDB: any = [];
  lookupLanguageProficiency: ILookupBase[];
  canPrintSpanish: boolean = false;
  reportParamArray: IReportParameter[];
  minVisionHearingDate: Date;
  checkedTrue: boolean = true;
  checkedFalse: boolean = false

  constructor
    (
      private globals: Globals,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string,
      public router: Router,
      lookupService: LookupService,
      private _formAssessmentTeamSummaryService: FormAssessmentTeamSummaryService,
      reportService: ReportService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this._reportService = reportService;
  }

  ngOnInit(): void {
    this.LoadAssessmentTeamSummaryDetails();
    //this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    this.minVisionHearingDate = new Date();
    this.minVisionHearingDate.setDate(this._myGlobals.todaysDate.getDate() - 365);
  }

  LoadAssessmentTeamSummaryDetails(): void {
    this._formAssessmentTeamSummaryService.getFormAssessmentTeamSummary(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormAssessmentTeamSummary) => {
        this.formAssessmentTeamSummaryDB = res

        this.formAssessmentTeamSummaryDB.grade = this.studentInfo.gradeLevel;

        if (this.formAssessmentTeamSummaryDB.dateOfPlan != null) {
          this.formAssessmentTeamSummaryDB.dateOfPlan = new Date(this.formAssessmentTeamSummaryDB.dateOfPlan);
        }
        else {
          this.formAssessmentTeamSummaryDB.dateOfPlan = new Date(this.selectedIepInstance.meetingDate);
        }

        if (this.formAssessmentTeamSummaryDB.nextAnnualReview != null) {
          this.formAssessmentTeamSummaryDB.nextAnnualReview = new Date(this.formAssessmentTeamSummaryDB.nextAnnualReview);
        }
        else if (this.selectedIepInstance.annualDueDate != null) {
          this.formAssessmentTeamSummaryDB.nextAnnualReview = new Date(this.selectedIepInstance.annualDueDate.getFullYear() + 1, this.selectedIepInstance.annualDueDate.getMonth(), this.selectedIepInstance.annualDueDate.getDate());
        }

        if (this.formAssessmentTeamSummaryDB.triennialDue != null) {
          this.formAssessmentTeamSummaryDB.triennialDue = new Date(this.formAssessmentTeamSummaryDB.triennialDue);
        }
        else if (this.selectedIepInstance.triAnnualDueDate != null) {
          this.formAssessmentTeamSummaryDB.triennialDue = new Date(this.selectedIepInstance.triAnnualDueDate);
        }

        if (this.formAssessmentTeamSummaryDB.homeLanguage == null) {
          this.formAssessmentTeamSummaryDB.homeLanguage = this._myGlobals.selectedStudent.elStatus;
        }

        if (this.formAssessmentTeamSummaryDB.hearingScreeningDate != null) {
          this.formAssessmentTeamSummaryDB.hearingScreeningDate = new Date(this.formAssessmentTeamSummaryDB.hearingScreeningDate);
        }
        if (this.formAssessmentTeamSummaryDB.languageSpeechSpecialistDate != null) {
          this.formAssessmentTeamSummaryDB.languageSpeechSpecialistDate = new Date(this.formAssessmentTeamSummaryDB.languageSpeechSpecialistDate);
        }
        if (this.formAssessmentTeamSummaryDB.nextAnnualReview != null) {
          this.formAssessmentTeamSummaryDB.nextAnnualReview = new Date(this.formAssessmentTeamSummaryDB.nextAnnualReview);
        }
        if (this.formAssessmentTeamSummaryDB.otherSpecifyDate != null) {
          this.formAssessmentTeamSummaryDB.otherSpecifyDate = new Date(this.formAssessmentTeamSummaryDB.otherSpecifyDate);
        }
        if (this.formAssessmentTeamSummaryDB.resourceSpecialistDate != null) {
          this.formAssessmentTeamSummaryDB.resourceSpecialistDate = new Date(this.formAssessmentTeamSummaryDB.resourceSpecialistDate);
        }
        if (this.formAssessmentTeamSummaryDB.schoolNurseDate != null) {
          this.formAssessmentTeamSummaryDB.schoolNurseDate = new Date(this.formAssessmentTeamSummaryDB.schoolNurseDate);
        }
        if (this.formAssessmentTeamSummaryDB.schoolPsychologistDate != null) {
          this.formAssessmentTeamSummaryDB.schoolPsychologistDate = new Date(this.formAssessmentTeamSummaryDB.schoolPsychologistDate);
        }
        if (this.formAssessmentTeamSummaryDB.specialEducationTeacherDate != null) {
          this.formAssessmentTeamSummaryDB.specialEducationTeacherDate = new Date(this.formAssessmentTeamSummaryDB.specialEducationTeacherDate);
        }
        if (this.formAssessmentTeamSummaryDB.teacher1Date != null) {
          this.formAssessmentTeamSummaryDB.teacher1Date = new Date(this.formAssessmentTeamSummaryDB.teacher1Date);
        }
        if (this.formAssessmentTeamSummaryDB.teacher2Date != null) {
          this.formAssessmentTeamSummaryDB.teacher2Date = new Date(this.formAssessmentTeamSummaryDB.teacher2Date);
        }
        if (this.formAssessmentTeamSummaryDB.triennialDue != null) {
          this.formAssessmentTeamSummaryDB.triennialDue = new Date(this.formAssessmentTeamSummaryDB.triennialDue);
        }
        if (this.formAssessmentTeamSummaryDB.visionScreeningDate != null) {
          this.formAssessmentTeamSummaryDB.visionScreeningDate = new Date(this.formAssessmentTeamSummaryDB.visionScreeningDate);
        }
        this.canPrintSpanish = this.formAssessmentTeamSummaryDB.rdlFileNameSpanish != '';
      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELLanguageProficiency])
      .subscribe((res: ILookupBase[]) => {
        this.lookupLanguageProficiency = res
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formAssessmentTeamSummaryService.insertUpdateFormAssessmentTeamSummary(this.formAssessmentTeamSummaryDB)
      .subscribe((res: IFormAssessmentTeamSummary) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        // Include any statements that you wnt to avoid
        this.validateForm();
        this.LoadAssessmentTeamSummaryDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  validateForm() {
    this._formAssessmentTeamSummaryService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadAssessmentTeamSummaryDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formAssessmentTeamSummaryDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formAssessmentTeamSummaryDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formAssessmentTeamSummaryDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formAssessmentTeamSummaryDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
